<template>
  <div class="related-events-component">
    <div class="related-events-header">
      <span>
        Event staffing based on expected participation
      </span>
      <span class="header-number more-margin-left">
        Screeners: {{ calScreeners }}
      </span>
      <span class="header-number">
        Coaches: {{ calCoaches }}
      </span>
      <span class="header-number">
        Leads: {{ calLeads }}
      </span>
    </div>
    <div class="related-events-body">
      <div class="other-events-header">
        <div class="other-events-header-left">
          <span class="other-events-title">Other event</span><br/>
          <div class="other-event-description">
            <span >Events pending approval and approved on this day that might impact this one.</span>
          </div>
        </div>
        <div class="other-events-header-right">
          <div class="other-related-events-info">
            <div class="text-related-info">
              <span>{{ countApproved }} approved events on this date in {{item.state}}</span><br/><br/>
              <span>{{ countSubmitted}} total approved events on this date</span>
            </div>
          </div>
          <div class="other-related-events-selection">
            <template v-for="item in selectItems">
              <EventStatusSelection class="menu-item" :item="item"></EventStatusSelection>
            </template>
          </div>
        </div>
      </div>
      <div class="other-events-body">
        <TableRelatedEvents class="modal-body-changeOrderDetail-event-detail" :editable="false"
                            :eventId="item.id"></TableRelatedEvents>
      </div>
    </div>
  </div>
</template>

<script>
  import constants from '../../_consts';
  import EventStatusSelection from '@/components/relatedEvents/EventStatusSelection';
  import TableRelatedEvents from './TableRelatedEvents';
  import { mapGetters } from 'vuex';

  export default {
    name: 'related-event',
    components: {
      EventStatusSelection,
      TableRelatedEvents
    },
    props: {
      item: {
        type: Object
      }
    },
    data () {
      return {
        viewMode: constants.dataTableViewModes
      }
    },
    computed: {
      listEventStatus () {
        return this.getListEventStatus;
      },
      ...mapGetters({
        getListEventStatus: 'GETTERS_LIST_EVENT_STATUS'
      }),
      calScreeners () {
        if (this.item.addOns.indexOf(constants.listAdditionalServicesKey.smallSiteModel) >= 0 || this.item.addOns.indexOf(constants.listAdditionalServicesKey.smallSiteConcierge) >= 0) {
          return 0;
        }
        return Math.ceil(this.item.projPart / this.item.duration / 4);
      },
      calCoaches () {
        if (this.item.addOns.indexOf(constants.listAdditionalServicesKey.smallSiteConcierge) >= 0) {
          return 1;
        }
        return Math.ceil(this.calScreeners / 3);
      },
      calLeads () {
        console.log('LEAD = ', this.item.addOns);
        if (this.item.addOns.indexOf(constants.listAdditionalServicesKey.smallSiteModel) >= 0) {
          return 1;
        }
        return Math.ceil(this.calScreeners / 7);
      },
      countSubmitted () {
        if (!this.item.relatedInfo) {
          return 0;
        }
        let arr = this.item.relatedInfo.filter(function (item) {
          return item.status.toLowerCase() === constants.eventStatus.submitted.toLowerCase();
        });
        return arr.length > 0 ? arr[0].countTotal : 0;
      },
      countApproved () {
        if (!this.item.relatedInfo) {
          return 0;
        }
        let arr = this.item.relatedInfo.filter(function (item) {
          return item.status.toLowerCase() === constants.eventStatus.approved.toLowerCase();
        });
        return arr.length > 0 ? arr[0].countTotal : 0;
      },
      selectItems () {
        return [
          {
            eventStatus: 'approved',
            name: 'Approved',
            url: '',
            icon: constants.iconNames.calendar,
            lineColor: 'line-green',
            routeTitle: 'Approved',
            count: this.countApproved
          },
          {
            eventStatus: 'submitted',
            name: 'Submitted to ADURO',
            url: '',
            icon: constants.iconNames.inbox,
            lineColor: 'line-blue',
            routeTitle: 'Submitted to ADURO',
            count: this.countSubmitted
          }
        ]
      }
    },
    watch: {
      listEventStatus: {
        handler: function () {
        }
      }
    },
    methods: {
    }
  }
</script>

<style lang="less" scoped>
  @import '~@/styles/variables.less';
  @import '~@/styles/customstyle.less';
  .related-events-component{
    margin-top: 10px;
    background-color: #E6E6E6;
    .related-events-header{
      height: 18px;	color: #231F20;	font-family: "Open Sans";	font-size: 14px;	line-height: 18px;
      .header-number{
        margin-left: 25px;
      }
      .more-margin-left{
        margin-left: 50px;
      }
    }
    .related-events-body{
      margin-top: 70px;
      .other-events-header{
        height: 100px;
        .other-events-header-left{
          float: left;
          .other-events-title{
            height: 29px;	color: #231F20;	font-family: Arquitecta;	font-size: 24px;	font-weight: bold;	line-height: 29px;
            text-transform: uppercase;
          }
          .other-event-description{
            margin-top: 16px;
            width: 330px;
            color: #231F20;	font-family: "Open Sans";	font-size: 14px;	line-height: 18px;
          }
        }
        .other-events-header-right{
          float: right;
          height: 95px;
          width: 652px;
          background-color: #3D6274;
          .other-related-events-info{
            width: 366px;
            float: left;
            .text-related-info{
              margin: 20px 0 0 20px;
              color: #FFFFFF;	font-family: "Open Sans";	font-size: 14px;	font-weight: bold;	line-height: 18px;
            }
          }
          .other-related-events-selection{
            float: right;
            width: 286px;
            .menu-item {
              float: right;
              width: 114px;
              color: @white;
              margin-right: 20px;
              a {
                display: block;
                color: @white;
              }

              &:hover {
                color: @white !important;
                background: #20a8d8 !important;
                cursor: pointer;
              }
            }
          }
        }
      }
      .other-events-body{

      }
    }
  }
</style>



// WEBPACK FOOTER //
// RelatedEvent.vue?4e6ebf4c